const namespaces = {};

/**
 * Shorthand for setting up pubsubs
 * @param {*} namespace - the prefix namespace to be used for this pubsub
 */
const PubsubRegister = (namespace) => {
  const namespaceUpper = namespace.toUpperCase();
  if (!namespaces[namespaceUpper]) {
    namespaces[namespaceUpper] = {
      namespace: namespaceUpper,
      publish: (eventName, eventData) => {
        if (window.ikea && window.ikea.pubsub) {
          window.ikea.pubsub.publish(
            `${namespaceUpper}/${eventName}`,
            eventData
          );
        }
      },
      subscribe: (eventName, callback) => {
        if (window.ikea && window.ikea.pubsub) {
          window.ikea.pubsub.subscribe(
            `${namespaceUpper}/${eventName}`,
            callback
          );
        }
      },
    };
  }
  return namespaces[namespaceUpper];
};

export default PubsubRegister;
